import { ReactSVG } from "react-svg"
import { useNavigate, useLocation } from "react-router";
import wlhLogoMobile from "../../../assets/images/enhanced-sign-in/wlh-logo.svg";
import wlhLogoDesktop from "../../../assets/images/enhanced-sign-in/desktop-wlh-logo.svg";
import { validateLocale } from "../../../utils/locale";

const InteractivePortalLogo = ({ isDesktop = false, className = "", isLogoClickDisabled = false }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const locale = validateLocale(query.get('locale'));

    const handleLogoClick = () => {
        if (!isLogoClickDisabled) {
            navigate(`/sign-in?locale=${locale}`);
        }
    };

    return (
        <div>
            {isDesktop ? (
                <ReactSVG
                    className={className}
                    src={wlhLogoDesktop}
                    onClick={handleLogoClick}
                />
            ) : (
                <ReactSVG
                    className={className}
                    src={wlhLogoMobile}
                    onClick={handleLogoClick}
                />
            )}
        </div>
    )
}

export default InteractivePortalLogo
